<template>
  <span>
    <span v-if="typeof user !== 'undefined'">
      <span v-if="!present">
        <!-- <router-link :to="'/user/' + user.id" onclick="return false;"> -->
          <i class="fa fa-user"></i> {{ user.name }}
        <!-- </router-link> -->
      </span>
    </span>
    <span v-else>
      <pulse-loader color="#cccccc" size="8px"></pulse-loader>
    </span>
  </span>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    name: 'user',
    components: {
      PulseLoader
    },
    props: ['present', 'item'],
    computed: {
      user () {
        let self = this

        if (this.item) {
          return this.item
        } else if (this.id) {
          return this.$store.getters['users/all'].find(item => item.id === self.id)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// User.vue?05b9c2f3